<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex lg7 md7 sm8 xs12>
        <h2 class='amaze-title'>Amaze</h2>
        <p>Enter your information below to create an account.</p>
        <v-form ref="registerForm" v-model="valid">
          <v-text-field label="First Name" :rules="firstNameRules" v-model="first_name" required></v-text-field>
          <v-text-field label="Last Name" :rules="lastNameRules" v-model="last_name" required></v-text-field>
          <v-text-field label="E-mail Address" v-model="email" :rules="emailRules" required></v-text-field>
          <p class='mt-3'>Passwords must be at least 8 characters, contain at least one upper case letter and at least one digit.</p>
          <v-text-field label="Password" v-model="password" :rules="passwordRules" required type='password'></v-text-field>
          <v-btn color="primary" class="mt-5" @click="submitForm()">
            Register
          </v-btn>
        </v-form>
        <p class='mt-3'>
          <router-link to="/">Return to Login</router-link>
        </p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      valid: false,
      first_name: "",
      firstNameRules: [v => !!v || "First name is required"],
      last_name: "",
      lastNameRules: [v => !!v || "Last name is required"],
      email: "",
      emailRules: [
        v => !!v || "Email is required",
        v => /@/.test(v) || "Don't forget the @ symbol"
      ],
      password: "",
      passwordRules: [
        v => /[A-Z]/.test(v) || "Passwords have at least one upper case letter",
        v => /[0-9]/.test(v) || "Passwords have at least one upper digitr",
        v => v.length >= 8 || "Passwords must be 8 or more characters"
      ]
    };
  },
  methods: {
    submitForm() {
      if (this.$refs.registerForm.validate()) {
        this.$auth.register({
          redirect: "/",
          body: {
            email: this.email,
            password: this.password,
            first_name: this.first_name,
            last_name: this.last_name,
            school_id: 1,
            district_id: 1
          },
          error(response) {
            this.$store.commit("updateMessage", {
              message: response.body.message,
              snackbar: true
            });
          }
        });
      } else {
        this.$store.commit("updateMessage", {
          message:
              "Nice try, but some required information is missing. Give it another go!",
          snackbar: true
        });
      }
    }
  }
};
</script>
